import type { TDictObject } from '../shared/IDirectoriesService';

import type { ContextOption } from './alert-rules-table/components/AlertRuleContextSelectionPanel';
import type { TOption } from './types';

export const toOptions = (list: TDictObject[], nameKey = 'name'): ContextOption[] => {
  return list.map((obj) => ({
    label: (obj.data[nameKey]?.toString() ?? '').trim() || String(obj.id),
    value: typeof obj.id === 'number' ? obj.id : Number(obj.id) || 0,
  }));
};

export const uniqueOptions = (options: TOption[]): TOption[] => {
  const values = new Set<string | number>();

  return options.filter((option) => {
    if (values.has(option.value)) {
      return false;
    }

    values.add(option.value);
    return true;
  });
};

export const isColumnsOrderModelEqual = (left: string[] | undefined, right: string[]): boolean => {
  return (left?.length ?? 0) === right.length && right.every((field, index) => left?.[index] === field);
};

/**
 * Приводит сохранённую сортировку колонок к текущему набору колонок.
 *
 * В настройках юзера лежит сортировка, сохранённая когда-то раньше. Если после этого в код добавили
 * колонку (или убрали), сохранённая сортировка не совпадёт с текущей по составу.
 *
 * Выкидываем поля, которых больше нет, а новые вставляем туда же, где они стоят в дефолтных колонках —
 * сразу за своим левым соседом.
 *
 * fields: [Название, Зона, Глубина, Секция]  (новый набор колонок)
 * saved:  [Глубина, Название, Зона]          (сохранённая сортировка)
 * merged: [Глубина, Секция, Название, Зона]  (Секция встала за Глубиной, как в новых колонках)
 */
export const mergeColumnsOrderModel = (saved: string[] | undefined, fields: string[]): string[] => {
  if (!saved?.length) {
    return [];
  }

  const merged = saved.filter((field) => fields.includes(field));

  fields.forEach((field, index) => {
    if (merged.includes(field)) {
      return;
    }

    const previousField = fields[index - 1];

    merged.splice(previousField ? merged.indexOf(previousField) + 1 : 0, 0, field);
  });

  return merged;
};
